/* eslint-disable no-underscore-dangle */
/* eslint-disable react/button-has-type */
/* eslint-disable no-console */
import { NUMERATE_FROM_START } from 'constants/defaultConstants';
import { useTranslate } from 'hooks/useTranslate';
import { useEffect, useState } from 'react';

const AddNewClass = ({
  setCreateClassInsite,
  holdingClasses,
  setHoldingClasses,
}) => {
  const { t } = useTranslate();

  const [name, setName] = useState('');
  const [numerationOption, setNumerationOption] = useState(
    holdingClasses?.[0]?.id
  );

  useEffect(() => {
    setNumerationOption(holdingClasses?.[0]?.id);
  }, [holdingClasses]);

  function saveClass(event) {
    event.preventDefault();
    const currentId = holdingClasses?.length;
    const newHoldingClass = {
      id: currentId,
      name,
      numerationOption:
        numerationOption !== NUMERATE_FROM_START ? numerationOption : null,
    };
    setHoldingClasses([...holdingClasses, newHoldingClass]);
    setCreateClassInsite(false);
  }

  return (
    <>
      <form className="form-validate is-alter m-2">
        <label
          className="form-label d-flex justify-between align-center"
          htmlFor="email-address"
        >
          <span>{t('NewClass')}</span>
          <em
            className="icon ni ni-cross text-primary"
            onClick={() => {
              setCreateClassInsite(false);
            }}
          />
        </label>

        <div
          className="row"
          style={{
            marginBottom: '20px',
          }}
        >
          <div className="col d-flex">
            <div className="form-group col-6 mb-0 p-0">
              <div className="form-control-wrap">
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  placeholder={t('ClassName')}
                  required
                />
              </div>
            </div>
            <div className="form-group col-6 mb-0 p-0">
              <div className="form-control-wrap">
                <div className="form-control-select">
                  <select
                    className="form-control"
                    value={numerationOption}
                    onChange={(event) =>
                      setNumerationOption(event.target.value)
                    }
                  >
                    {holdingClasses?.map((holdingClass) => (
                      <option
                        value={holdingClass.id}
                        key={`class-${holdingClass.id}`}
                      >
                        {holdingClass.name} ({t('NumberFromTheLastClassPar')}{' '}
                        &quot;
                        {holdingClass.name}&quot;)
                      </option>
                    ))}
                    <option>{NUMERATE_FROM_START}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          className="btn btn-block btn-dim btn-light mb-2"
          disabled={!name}
          onClick={saveClass}
        >
          {t('AddClass')}
        </button>
      </form>
    </>
  );
};

export default AddNewClass;
